/*
 * Authorization Roles
 */
const authRoles = {
  user: ["USER"],
  onlyGuest: [],
};

export default authRoles;
